import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { AuthShell } from "@/components/AuthShell";
import { useAuth, formatApiErrorDetail } from "@/context/AuthContext";
import { Loader2, ShieldCheck } from "lucide-react";

const fieldCls =
  "w-full bg-white border border-black/10 rounded-2xl px-4 py-3.5 text-sm text-[#1A1A1A] placeholder:text-[#A3A3A3] focus:outline-none focus:border-[#A78BFA] focus:ring-2 focus:ring-[#A78BFA]/15 transition-colors";

export default function AdminLoginPage() {
  const { loginAdmin } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError("");
    try {
      await loginAdmin(email.trim().toLowerCase(), password);
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err?.response?.data?.detail) || "Credenziali non valide");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <AuthShell
      testId="admin-login-page"
      subtitle="Super Admin"
      title="Pannello AURA."
      footer={<span className="inline-flex items-center gap-1.5"><ShieldCheck size={14} /> Accesso riservato</span>}
    >
      <form onSubmit={onSubmit} className="space-y-4" data-testid="admin-login-form">
        <label className="block">
          <span className="block text-[10px] tracking-[0.25em] uppercase text-[#737373] mb-2">Email</span>
          <input data-testid="admin-login-email" type="email" required value={email}
            onChange={(e) => setEmail(e.target.value)} placeholder="super@aura-crm.it" className={fieldCls} />
        </label>
        <label className="block">
          <span className="block text-[10px] tracking-[0.25em] uppercase text-[#737373] mb-2">Password</span>
          <input data-testid="admin-login-password" type="password" required value={password}
            onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" className={fieldCls} />
        </label>
        {error && (
          <div data-testid="admin-login-error" className="text-sm text-[#B91C1C] bg-[#FEE2E2] border border-[#FCA5A5] rounded-2xl px-4 py-2.5">
            {error}
          </div>
        )}
        <button type="submit" data-testid="admin-login-submit" disabled={submitting}
          className="w-full inline-flex items-center justify-center gap-2 bg-[#1A1A1A] hover:bg-[#333] disabled:opacity-60 text-white rounded-full px-6 py-3.5 text-sm tracking-wide">
          {submitting && <Loader2 size={16} className="animate-spin" />}
          {submitting ? "Accesso…" : "Accedi"}
        </button>
      </form>
    </AuthShell>
  );
}
